import { FC } from 'react';
import { KPI } from '@/types/common';

interface KPICardProps {
  kpi: KPI;
}

export const KPICard: FC<KPICardProps> = ({ kpi }) => {
  const formattedValue = typeof kpi.value === 'number'
    ? kpi.value.toLocaleString()
    : kpi.value;

  return (
    <div className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow duration-200">
      <h3 className="text-gray-600 text-sm font-medium mb-2">
        {kpi.title}
      </h3>
      <p className="text-3xl font-bold text-blue-900 mb-1">
        {formattedValue}
      </p>
      <span className="text-xs text-gray-500">
        {kpi.subtitle}
      </span>
    </div>
  );
};

